{
  "Balance recovery": {
    "en": "Balance recovery",
    "de": "Standfestigkeit"
  },
  "Cudgel": {
    "en": "Cudgel",
    "de": "Knüppel"
  },
  "Dagger": {
    "en": "Dagger",
    "de": "Dolch"
  },
  "Depth": {
    "en": "Depth",
    "de": "Tiefe"
  },
  "Drawing back": {
    "en": "Drawing back",
    "de": "Zurückholen"
  },
  "Fighter": {
    "en": "Fighter",
    "de": "Kämpfer"
  },
  "Follow-through": {
    "en": "Follow-through",
    "de": "Nachsetzen"
  },
  "Ghost": {
    "en": "Ghost",
    "de": "Gespenst"
  },
  "Guard": {
    "en": "Guard",
    "de": "Deckung"
  },
  "Healer": {
    "en": "Healer",
    "de": "Heiler"
  },
  "Lumina": {
    "en": "Lumina",
    "de": "Lumina"
  },
  "Mace": {
    "en": "Mace",
    "de": "Streitkolben"
  },
  "Moonstone": {
    "en": "Moonstone",
    "de": "Mondstein"
  },
  "North Wood": {
    "en": "North Wood",
    "de": "Nordwald"
  },
  "Purse": {
    "en": "Purse",
    "de": "Geldbeutel"
  },
  "Short sword": {
    "en": "Short sword",
    "de": "Kurzschwert"
  },
  "Sopors": {
    "en": "Sopors",
    "de": "Sopors"
  },
  "Spirit deepening": {
    "en": "Spirit deepening",
    "de": "Geistesstärke"
  },
  "Strike": {
    "en": "Strike",
    "de": "Schlag"
  },
  "Touch": {
    "en": "Touch",
    "de": "Berührung"
  },
  "Toughening": {
    "en": "Toughening",
    "de": "Abhärtung"
  },
  "Umbrae": {
    "en": "Umbrae",
    "de": "Umbrae"
  },
  "Vigils": {
    "en": "Vigils",
    "de": "Vigils"
  }
}
